import { ResponsePayload } from "@/types/model";
import { getData } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getSitemap = async (
  token: string,
  baseUrl: string,
  params?: object,
  config?: object
) => {
  const queryPath = `${baseUrl}/sitemap`;
  return await getData(token, queryPath, params, config).then(
    (response: ResponsePayload) => deserialize(response.data)
  );
};
